<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    width="720px"
    append-to-body
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    @closed="handleClosed">
    <el-form
      ref="ruleForm"
      :model="info"
      :rules="rules"
      label-width="100px">
      <el-form-item
        label="商家编码："
        prop="customerNumber">
        <el-input v-model="info.customerNumber"></el-input>
      </el-form-item>
      <el-form-item
        label="商家名称："
        prop="name">
        <el-input v-model="info.name"></el-input>
      </el-form-item>
      <el-form-item
        label="联系人："
        prop="contactMan">
        <el-input v-model="info.contactMan"></el-input>
      </el-form-item>
      <el-form-item
        label="联系电话："
        prop="contactPhone">
        <el-input v-model="info.contactPhone"></el-input>
      </el-form-item>
      <el-form-item
        label="商家地址："
        prop="address">
        <el-input v-model="info.address"></el-input>
      </el-form-item>
      <el-form-item
        label="信誉等级："
        prop="level">
        <el-rate
          v-model="info.level"
          :max="6"></el-rate>
      </el-form-item>
      <el-form-item
        label="有效日期："
        prop="validDate">
        <el-date-picker
          v-model="info.validDate"
          :editable="false"
          type="date"
          placeholder="选择日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item
        label="信誉文件："
        prop="images">
        <upload-with-crop
          v-model="info.images"
          :isLt2M="2048"
          :limit="5"
          :autoCropWidth="100"
          :autoCropHeight="100"></upload-with-crop>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button
        :loading="loading"
        @click="visible = false">
        取 消
      </el-button>
      <el-button
        type="primary"
        :loading="loading"
        @click="handleSubmit">
        确 定
      </el-button>
    </span>
  </el-dialog>
</template>
<script>
import UploadWithCrop from '../../../components/public/upload-with-crop.vue'
export default {
  name: 'EditCreditModal',
  components: { UploadWithCrop },
  props: {
    callback: {
      type: Function
    }
  },
  data() {
    return {
      loading: false,
      visible: false,
      info: {
        id: null,
        customerNumber: '',
        name: '',
        contactMan: '',
        contactPhone: '',
        address: '',
        level: 6,
        validDate: null,
        images: []
      },
      rules: {
        customerNumber: [
          { required: true, message: '请商家编码', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '请输入商家名称', trigger: 'blur' }
        ],
        contactMan: [
          { required: true, message: '请输入联系人', trigger: 'blur' }
        ],
        contactPhone: [
          { required: true, message: '请输入联系电话', trigger: 'blur' }
        ],
        address: [
          { required: true, message: '请输入商家地址', trigger: 'blur' }
        ],
        level: [
          { required: true, message: '请选择信誉等级', trigger: 'blur' }
        ],
        validDate: [
          { required: true, message: '请选择信誉等级有效截止日期', trigger: 'blur' }
        ],
        images: [
          { required: true, message: '请上传信誉文件', trigger: 'change' }
        ]
      }
    }
  },
  computed: {
    title() {
      const id = this.info.id
      return (id ? '编辑' : '新增') + '商家信誉'
    }
  },
  methods: {
    handleClosed() {
      this.info = {
        id: null,
        customerNumber: '',
        name: '',
        contactMan: '',
        contactPhone: '',
        address: '',
        level: 6,
        validDate: null,
        images: []
      }
      this.$refs.ruleForm.resetFields()
    },
    handleSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.loading = true
          const dispatch = this.info.id ? 'updatecustomercredit' : 'addcustomercredit'
          this.$store.dispatch(`account/${dispatch}`, {
            payload: {
              ...this.info,
              validDate: +this.info.validDate,
              images: this.info.images.map(i => i.url).join(',')
            },
            success: () => {
              this.loading = false
              this.visible = false
              this.$message.success('保存成功')
              this.callback && this.callback()
            },
            fail: () => {
              this.loading = false
            }
          })
        }
      })
    },
    edit(options = {}) {
      this.$set(this, 'info', { ...this.info, ...options })
      this.visible = true
    }
  }
}
</script>
